<script setup lang="ts">
import ToggleSlider from '@/core/elements/ToggleSlider.vue';

withDefaults(
  defineProps<{
    title: string;
    description: string;
    modelValue: boolean;
    disabled?: boolean;
    disabledTheme?: 'muted' | 'success';
    toggleAriaLabel: string;
  }>(),
  {
    disabled: false,
    disabledTheme: 'muted',
  },
);

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void;
}>();
</script>

<template>
  <div class="flex items-start gap-[12px]">
    <div class="min-w-0 flex-1">
      <p class="text-footer leading-[160%] tracking-[0.01em] font-semibold">{{ title }}</p>
      <p class="text-footer leading-[160%] tracking-[0.01em]">{{ description }}</p>
    </div>

    <ToggleSlider
      class="mt-[1px] shrink-0"
      :model-value="modelValue"
      :disabled="disabled"
      :disabled-theme="disabledTheme"
      :aria-label="toggleAriaLabel"
      @update:model-value="emit('update:modelValue', $event)"
    />
  </div>
</template>
